import { IRemoteOcr } from "./IRemoteOcr";


export class DemoOcr implements IRemoteOcr
{
    public UploadAndScan(image: Blob): Promise<string | null>
    {
        alert("W sesji demo OCR nie jest dostępny!");

        return Promise.resolve(null);
    }
}
